<template>
  <div id="box">

    <div class="label" v-for="(item,index) in datainfo.data[0].formObjects" :key="index">
      <div class="l">{{item.name}}</div>
      <div class="r">{{item.value | jsonStrParse('value') | getStatusByValue(item.statusMap) }}</div>
    </div>

    <el-table ref="t1" :data="tableData" border>
      <el-table-column prop="name" label=" " :width="remtopx(0.53)">
      </el-table-column>
      <el-table-column prop="col1" :label="datainfo.data[1].listObjects[0].titles[0]" :width="remtopx(0.4)">
      </el-table-column>
      <el-table-column prop="col2" :label="datainfo.data[1].listObjects[0].titles[1]" :width="remtopx(0.4)">
      </el-table-column>
      <el-table-column prop="col3" :label="datainfo.data[1].listObjects[0].titles[2]" :width="remtopx(0.4)">
      </el-table-column>
      <el-table-column prop="col4" :label="datainfo.data[1].listObjects[0].titles[3]" :width="remtopx(0.67)">
      </el-table-column>
    </el-table>

    <el-table ref="t2" :data="tableData1" border>
      <el-table-column prop="name" label=" " :width="remtopx(0.53)">
      </el-table-column>
      <el-table-column prop="col1" :label="datainfo.data[1].listObjects[1].titles[0]" :width="remtopx(0.34)">
      </el-table-column>
      <el-table-column prop="col2" :label="datainfo.data[1].listObjects[1].titles[1]" :width="remtopx(0.34)">
      </el-table-column>
      <el-table-column prop="col3" :label="datainfo.data[1].listObjects[1].titles[2]" :width="remtopx(0.34)">
      </el-table-column>
      <el-table-column prop="col4" :label="datainfo.data[1].listObjects[1].titles[3]" :width="remtopx(0.44)">
      </el-table-column>
      <el-table-column prop="col5" :label="datainfo.data[1].listObjects[1].titles[4]" :width="remtopx(0.44)">
      </el-table-column>
    </el-table>

    <div class="status">
      <div class="l">
        <div :class="filterJsonStrParse(datainfo.data[2].picObjects[0].value,'value')===1?'open':'close'"></div>
        <div class="text">{{datainfo.data[2].picObjects[0].name}}</div>
      </div>
      <div class="r">
        <div :class="filterJsonStrParse(datainfo.data[2].picObjects[1].value,'value')===1?'open':'close'"></div>
        <div class="text">{{datainfo.data[2].picObjects[1].name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import img from "../img/6.png";
// import cfg from "./config.js";
export default {
  name:'bms',
  props: ['datainfo'],
  mounted(){
    this.tableData[0].name = this.datainfo.data[1].listObjects[0].data[0].column
    this.tableData[0].col1 = this.filterJsonStrParse(this.datainfo.data[1].listObjects[0].data[0].values[0].value,'value')
    this.tableData[0].col2 = this.filterJsonStrParse(this.datainfo.data[1].listObjects[0].data[0].values[1].value,'value')
    this.tableData[0].col3 = this.filterJsonStrParse(this.datainfo.data[1].listObjects[0].data[0].values[2].value,'value')
    this.tableData[0].col4 = this.filterJsonStrParse(this.datainfo.data[1].listObjects[0].data[0].values[3].value,'value')

    this.tableData1[0].name = this.datainfo.data[1].listObjects[1].data[0].column
    this.tableData1[0].col1 = this.filterJsonStrParse(this.datainfo.data[1].listObjects[1].data[0].values[0].value,'value')
    this.tableData1[0].col2 = this.filterJsonStrParse(this.datainfo.data[1].listObjects[1].data[0].values[1].value,'value')
    this.tableData1[0].col3 = this.filterJsonStrParse(this.datainfo.data[1].listObjects[1].data[0].values[2].value,'value')
    this.tableData1[0].col4 = this.filterJsonStrParse(this.datainfo.data[1].listObjects[1].data[0].values[3].value,'value')
    this.tableData1[0].col5 = this.filterJsonStrParse(this.datainfo.data[1].listObjects[1].data[0].values[4].value,'value')

    this.tableData1[1].name = this.datainfo.data[1].listObjects[1].data[1].column
    this.tableData1[1].col1 = this.filterJsonStrParse(this.datainfo.data[1].listObjects[1].data[1].values[0].value,'value')
    this.tableData1[1].col2 = this.filterJsonStrParse(this.datainfo.data[1].listObjects[1].data[1].values[1].value,'value')
    this.tableData1[1].col3 = this.filterJsonStrParse(this.datainfo.data[1].listObjects[1].data[1].values[2].value,'value')
    this.tableData1[1].col4 = this.filterJsonStrParse(this.datainfo.data[1].listObjects[1].data[1].values[3].value,'value')
    this.tableData1[1].col5 = this.filterJsonStrParse(this.datainfo.data[1].listObjects[1].data[1].values[4].value,'value')
    this.resetTable('t1')
    this.resetTable('t2')

  },
  data() {
    return {
      tableData: [
        {
          name: "组端电压(v)",
          col1: 1500.2,
          col2: 1200.2,
          col3: 1300.2,
          col4: 15.6,
        },
      ],
      tableData1: [
        {
          name: "单体电压(v)",
          col1: 3.558,
          col2: 3.122,
          col3: 0.255,
          col4: 1,
          col5: 1,
        },
        {
          name: "单体温度(℃)",
          col1: 1,
          col2: 15.6,
          col3: 3,
          col4: 1,
          col5: 1,
        },
      ],
    };
  },
  methods: {
    resetTable(r){
      this.$nextTick(() => {
            if (this.$refs[r]&& this.$refs[r].doLayout) {
              this.$refs[r].doLayout();
            }
      })
    },
    remtopx(rem) {
      return Math.floor((this._routerRoot.rem * rem) / 1.5);
    },
  },
};
</script>

<style lang="scss" scoped>
>>> .el-table {
  margin-top: 0.05rem;
  background-color: rgba(0, 0, 0, 0);
  border-right: 1px solid;
  border-color:  rgba($color: #0f69ca, $alpha: 0.12) !important;
}
>>> table {
  width: 100% !important;
}
>>> .el-table * {
  font-size: 0.07rem;
  color: #151a86;
  font-weight: 500;
  background: rgba($color: #000000, $alpha: 0) !important;
  border-color:  rgba($color: #0f69ca, $alpha: 0.12) !important;
}
>>> .el-table .el-table__header-wrapper {
  background-color: rgba($color: #0f69ca, $alpha: 0.05) !important;
}

>>> .el-table .el-table__row {
  border-right: 1px solid  rgba($color: #0f69ca, $alpha: 0.12) !important;
}
>>> .el-table__cell:first-child {
  border-right: 1px solid  rgba($color: #0f69ca, $alpha: 0.12) !important;
}
>>> .el-table__body .el-table__cell:first-child {
  background-color: rgba($color: #0f69ca, $alpha: 0.05) !important;
}
>>> .el-table__cell {
  border-right: none;
  text-align: center;
  height: 0.12rem !important;
  line-height: 0.12rem !important;
  padding: 0 0 0 0 !important;
}
>>> .cell {
  display: inline;
  line-height: 0.12rem;
  padding: 0 0 0 0 !important;
  zoom: 0.8;
  white-space: nowrap;
  overflow: inherit;
}
>>> .el-table--border::after {
  display: none;
}
>>> .el-table::before {
  display: none;
}
>>> .el-table th.gutter{
    display: table-cell!important;
}

#box {
  width: 1.6688rem;
  height: auto;
  // background-image: url(../img/6.png);
  background-size: 100% 100%;
  padding-top: 0.03rem;
}
.label {
  width: 100%;
  height: 0.145rem;
  color: #151a86;
  font-weight: 500;
  line-height: 0.145rem;
  .l {
    float: left;
    width: 50%;
    text-indent: 0.09rem;
    font-size: 0.01rem;
  }
  .r {
    float: right;
    width: 48%;
    text-align: center;
    font-size: 0.01rem;
  }
}
.label:nth-child(2n) {
  background: rgba($color: #0f69ca, $alpha: 0.12);
}

.status {
  width: 1.07rem;
  height: 0.3rem;
  margin-left: 0.28rem;
  .l {
    float: left;
    width: 0.28rem;
  }
  .r {
    float: right;
    width: 0.28rem;
  }
  .text {
    width: 0.5rem;
    color: #151a86;
    font-weight:500;
    font-size: 0.01rem;
    margin-top: 0.02rem;
   white-space: nowrap!important;
    overflow: inherit!important;
  }
  .open {
    width: 0.28rem;
    height: 0.15rem;
    background-image: url(../img/open.png);
    background-size: 100% auto;
    background-position: center bottom;
    background-repeat: no-repeat;
  }
  .close {
    width: 0.28rem;
    height: 0.15rem;
    background-image: url(../img/close.png);
    background-size: 100% auto;
    background-position: center bottom;
    background-repeat: no-repeat;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/webgl/ui/data/bms.vue